module.exports = __webpack_public_path__ + "img/back_35.209689f4.svg";